import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

// Get saved language from localStorage or default to 'fr'
const getSavedLanguage = () => {
    return localStorage.getItem("orkestria_lang") || "fr";
};

i18n.use(initReactI18next).init({
    resources: {
        fr: { translation: fr },
        en: { translation: en },
        es: { translation: es },
    },
    lng: getSavedLanguage(),
    fallbackLng: "fr",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;

export const LANGUAGES = [
    { code: "fr", label: "Français", flag: "🇫🇷" },
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "es", label: "Español", flag: "🇪🇸" },
];

export const changeLanguage = async (lang, apiUrl = null, token = null) => {
    // Change language immediately in i18n
    i18n.changeLanguage(lang);
    localStorage.setItem("orkestria_lang", lang);
    
    // Persist to backend if API info provided
    if (apiUrl && token) {
        try {
            await fetch(`${apiUrl}/settings/language`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ language: lang }),
            });
        } catch (error) {
            console.error("Failed to save language preference:", error);
        }
    }
};

export const loadUserLanguage = async (apiUrl, token) => {
    try {
        const response = await fetch(`${apiUrl}/settings/language`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
            const data = await response.json();
            if (data.language && data.language !== i18n.language) {
                i18n.changeLanguage(data.language);
                localStorage.setItem("orkestria_lang", data.language);
            }
        }
    } catch (error) {
        console.error("Failed to load language preference:", error);
    }
};
